<template>
  <div class="hurix-empty">
    <div class="empty-illustration">
        <img src="@/assets/images/EmptyData.png" alt="" >
    </div>
    <div class="empty-title">{{ displayTitle }}</div>
    <div v-if="displaySubtitle" class="empty-subtitle">{{ displaySubtitle }}</div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'HurixEmpty',
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'fa-folder-open'
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.$t('system.NoData')
    },
    displaySubtitle() {
      return this.subtitle || ''
    }
  }
}
</script>

<style lang="scss" scoped>
.hurix-empty {
  background: none;
  border-radius: 20px;
  padding: 90px 20px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.01);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-illustration {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    height: 100%;
  }
}

.empty-icon {
  width: 34px;
  height: 34px;
  color: #ff7d3f;
}

// .empty-pulse-ring {
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   border: 2px solid rgba(255, 125, 63, 0.15);
//   border-radius: 50%;
//   animation: pulseScale 2s infinite;
// }

.empty-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e2f3e;
  margin-bottom: 6px;
}

.empty-subtitle {
  font-size: 13px;
  color: #7c94b0;
  max-width: 400px;
  line-height: 1.5;
  margin-bottom: 24px;
}

@keyframes smoothFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

@keyframes pulseScale {
  0% {
    transform: scale(0.95);
    opacity: 1;
  }
  100% {
    transform: scale(1.3);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HurixEmpty/index.vue